import React from "react";
import styled, { ThemeProvider } from "styled-components";
import theme from "../../style/theme";
import ButtonBase from "../button/ButtonBase";

interface IconProps {
  children?: any;
  color?: string;
  disable?: boolean;
  type?: string;
  size?: string;
  iconRef?: React.Ref<HTMLSpanElement>;
  sx?: any;
  onClick?: (e: any) => void;
  name?: string;
  className?: string;
}

const Icon: React.FC<IconProps> = ({
  children,
  onClick,
  iconRef,
  className,
  ...rest
}) => {
  return (
    <div style={{ height: "100%" }}>
      <ThemeProvider theme={theme}>
        <IconRoot
          as="span"
          onClick={onClick}
          ref={iconRef}
          {...rest}
          className={className}
        >
          {children}
        </IconRoot>
      </ThemeProvider>
    </div>
  );
};

export default Icon;

const IconRoot = styled(ButtonBase)`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  & svg {
    width: 24px;
    height: 24px;
  }
  & svg path {
    fill: ${(props: any) => props.theme.palette.primitives[props.color]};
    fill: ${(props: any) => props.theme.palette.foundation[props.color]};
  }

  ${(props: any) => props.sx};
`;

Icon.defaultProps = {
  color: "black",
};
